export enum ErrorsStatus {
	NEW = 'New',
	CONTACTING_CLIENT = 'Contacting client',
	WORKING_ON_IT = 'Working on it',
	FIXED = 'Fixed',
	// NOT_FIXED = 'Not Fixed',
}
export const ERRORS_STATUS = {
	[ErrorsStatus.NEW]: 'New',
	[ErrorsStatus.CONTACTING_CLIENT]: 'Contacting client',
	[ErrorsStatus.WORKING_ON_IT]: 'Working on it',
	[ErrorsStatus.FIXED]: 'Fixed',
	// [ErrorsStatus.NOT_FIXED]: 'Not Fixed',
};

export const representationSchemeType = {
	'IOSS-NON-UNION': 'Non-Union OSS',
	'IOSS-UNION': 'OSS',
	'IOSS-IMPORT': 'IOSS',
	'FC-REP': 'DDP/DDU Sales',
	// 'FC-SIMPLE-REP': 'DDP/DDU Sales',
	'B2B-INTRA-COMMUNAL': 'B2B',
	'B2B-DOMESTIC': 'B2B Domestic',
	'B2C-DOMESTIC': 'B2C Domestic',
	GIFTCARD_SCHEME: 'Gift Cards',
	NON_EU_IMPORT: 'NON EU Import',
	NON_EU_DOMESTIC: 'NON EU Domestic',
};
